export const getDocuments = async () => {
  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Basic ${process.env.REACT_APP_AWS_USER_TOKEN}`,
    },
  };

  let response = {};

  const processExe = () => {
    return new Promise((resolve, reject) => {
      fetch(`${process.env.REACT_APP_AWS_USER_ENDPOINT}/get-documents`, options)
        .then((resp) => resp.json())
        .then((data) => {
          response = {
            ...data,
          };
          resolve(data);
        })
        .catch((error) => {
          console.log(
            `[Helpers -> Get Documents]: Error in getting documents -> ${error}`
          );
          response = {
            status: 500,
            message: `Error in getting documents: [${error.message}]`,
          };
          reject(response);
        });
    });
  };

  await processExe();
  return response;
};

export const getPresignedUrl = async (Key) => {
  const options = {
    method: "POST",
    body: JSON.stringify({
      Key,
    }),
    headers: {
      "Content-Type": "application/json",
      Authorization: `Basic ${process.env.REACT_APP_AWS_USER_TOKEN}`,
    },
  };

  let response = {};

  const processExe = () => {
    return new Promise((resolve, reject) => {
      fetch(
        `${process.env.REACT_APP_AWS_USER_ENDPOINT}/get-presigned-url`,
        options
      )
        .then((resp) => resp.json())
        .then((data) => {
          response = {
            ...data,
          };
          resolve(response);
        })
        .catch((error) => {
          console.log(
            `[Helpers -> Get Presigned Url]: Error in getting presigned url -> ${error}`
          );
          response = {
            status: 500,
            message: `Error in getting presigned url: [${error.message}]`,
          };
          reject(response);
        });
    });
  };

  await processExe();
  return response;
};

export const uploadDocument = async (
  document_filename,
  document_content,
  document_contenttype
) => {
  const options = {
    method: "POST",
    body: JSON.stringify({
      document_filename,
      document_content,
      document_contenttype,
    }),
    headers: {
      "Content-Type": "application/json",
      Authorization: `Basic ${process.env.REACT_APP_AWS_USER_TOKEN}`,
    },
  };

  let response = {};

  const processExe = () => {
    return new Promise((resolve, reject) => {
      fetch(`${process.env.REACT_APP_AWS_USER_ENDPOINT}/add-document`, options)
        .then((resp) => resp.json())
        .then((data) => {
          response = {
            ...data,
          };
          resolve(response);
        })
        .catch((error) => {
          console.log(
            `[Helpers -> Add Document]: Error in adding a document -> ${error}`
          );
          response = {
            status: 500,
            message: `Error in adding a document: [${error.message}]`,
          };
          reject(response);
        });
    });
  };

  await processExe();
  return response;
};
